import { MainImages } from '@lemon/assets';

export const Definition = () => {
    return (
        <img
            className="w-full xl:w-1/2 h-auto xl:h-full object-cover"
            src={MainImages.problem}
            alt="Inspirational Background"
            onDragStart={e => e.preventDefault()}
        />
    );
};
